/* Globo V2 — Stepped product options */
(() => {

  function getConfigs() {
    const G = window.GPOConfigs;
    if (!G) return [];
    if (Array.isArray(G.options)) return G.options.filter(o => o && o.enable !== false);
    if (Array.isArray(G)) return G.filter(o => o && o.enable !== false);
    return [];
  }

  function extractPrice(elements) {
    for (const el of (elements || [])) {
      if (el.addon_product && el.addon_product.variant_price) return el.addon_product.variant_price;
      const found = extractPrice(el.elements);
      if (found !== null) return found;
    }
    return null;
  }

  function formatPrice(raw) {
    const n = parseFloat(raw);
    if (!n) return null;
    return '+$' + n.toFixed(2).replace(/\.00$/, '');
  }

  function isComplete(group) {
    for (const el of group.querySelectorAll('input[type="text"], input:not([type])')) {
      if (el.disabled) continue;
      const min = parseInt(el.getAttribute('minlength') || el.dataset.minlength || 0);
      if (min > 0 && el.value.trim().length < min) return false;
    }
    const radio = {};
    for (const r of group.querySelectorAll('input[type="radio"]')) {
      if (!radio[r.name]) radio[r.name] = { any: false, checked: false };
      if (!r.disabled) radio[r.name].any = true;
      if (r.checked)   radio[r.name].checked = true;
    }
    return Object.values(radio).every(g => !g.any || g.checked);
  }

  const CHECK = `<span class="globo-v2__check" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="7.5" stroke="#000"/><path d="M4.5 8.5l2.5 2.5 4.5-5.5" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>`;
  const SWITCH = `<span class="globo-v2__switch" aria-hidden="true"><span class="globo-v2__switch-knob"></span></span>`;

  class GloboV2 extends HTMLElement {
    connectedCallback() { this._wait(); }

    _wait() {
      if (this._findGroups()) return;
      const root = this.closest('.shopify-section') || document.body;
      const obs  = new MutationObserver(() => { if (this._findGroups()) obs.disconnect(); });
      obs.observe(root, { childList: true, subtree: true });
      setTimeout(() => obs.disconnect(), 8000);
    }

    _findGroups() {
      const scope  = this.closest('.shopify-section') || document;
      const groups = Array.from(scope.querySelectorAll('.gpo-group__wrapper'));
      if (!groups.length) return false;
      setTimeout(() => this._setup(groups), 400);
      return true;
    }

    _setup(groups) {
      const configs = getConfigs();

      this.steps = groups.map((group, i) => {
        const cfg = configs[i] || {};
        let label = cfg.name || null;
        if (!label) {
          const lc = group.querySelector('.label-content');
          if (lc) label = lc.textContent.trim();
        }
        label = label || `Option ${i + 1}`;

        let price = null;
        const addOn = group.querySelector('.addOn');
        if (addOn?.textContent.trim()) price = addOn.textContent.replace(/[()]/g, '').trim();
        if (!price) price = formatPrice(extractPrice(cfg.elements));

        return { group, label, price };
      });

      // Apply font styles after render, safely deferred
      requestAnimationFrame(() => {
        try {
          const FONT_MAP = [
            { key: 'sans serif', font: "'CND Sans', sans-serif" },
            { key: 'sans', font: "'CND Sans', sans-serif" },
            { key: 'serif', font: "'CND Serif', serif" },
            { key: 'cursive', font: "'CND Cursive', cursive" },
            { key: 'sloop script', font: "'CND Cursive', cursive" },
            { key: 'perandory condensed', font: "'CND Serif', serif" },
            { key: 'tan harmoni', font: "'CND Sans', sans-serif" },
          ];
          const getFont = (text) => {
            const lower = (text || '').trim().toLowerCase();
            for (const { key, font } of FONT_MAP) {
              if (lower.includes(key)) return font;
            }
            return null;
          };

          this.steps.forEach(step => {
            const group = step.group;
            // Style dropdown labels
            group.querySelectorAll('.dropdown-item__value').forEach(el => {
              const font = getFont(el.textContent);
              if (font) el.style.fontFamily = font;
            });

            // Create font preview only for the custom name input (not monogram initials)
            const inputs = group.querySelectorAll('input[type="text"]');
            let input = null;
            inputs.forEach(inp => {
              const placeholder = (inp.placeholder || '').toLowerCase();
              const name = (inp.name || '').toLowerCase();
              const id = (inp.id || '').toLowerCase();
              if ((placeholder.includes('name') || name.includes('name') || id.includes('name')) && !placeholder.includes('initial')) {
                input = inp;
              }
            });
            if (!input) return;

            const preview = document.createElement('div');
            preview.className = 'globo-v2__font-preview';
            preview.style.cssText = 'margin-top:12px;font-size:32px;min-height:40px;color:#333;word-break:break-word;padding:8px 0;border-top:1px solid #e5e5e5;';
            group.appendChild(preview);

            let currentFont = "'CND Sans', sans-serif";
            let updating = false;

            const updatePreview = () => {
              preview.textContent = input.value;
              preview.style.fontFamily = currentFont;
            };

            const checkFont = () => {
              if (updating) return;
              updating = true;
              // Find the checked radio for font selection
              const checkedRadio = group.querySelector('input[type="radio"][data-field-name="font-name"]:checked, input[type="radio"][name="font-name"]:checked');
              if (checkedRadio) {
                const f = getFont(checkedRadio.value);
                if (f) currentFont = f;
              }
              updatePreview();
              updating = false;
            };

            input.addEventListener('input', updatePreview);
            group.addEventListener('change', checkFont);
            const obs = new MutationObserver(checkFont);
            obs.observe(group, { attributes: true, subtree: true, attributeFilter: ['class', 'style', 'value', 'checked'] });
            setTimeout(checkFont, 0);
          });
        } catch(e) { /* font styling failed, accordion still works */ }
      });

      this.steps.forEach((step, i) => {
        const { group } = step;
        // IMPORTANT: never reparent Globo's rendered DOM. Globo binds delegated
        // listeners against its own ancestors and may re-query elements by their
        // original position. We therefore reuse Globo's existing elements as the
        // accordion container and collapsible body instead of moving them into
        // newly-created wrapper nodes.
        //   group    = .gpo-group__wrapper   (the content)
        //   gpoGroup = .gpo-group            (its parent, stays a child of `container`)
        const gpoGroup  = group.parentNode;   // .gpo-group — becomes the accordion
        const container = gpoGroup.parentNode; // Globo's outer container

        const total = container.querySelector('.gpo-total');
        if (total) total.style.display = 'none';

        // The accordion IS Globo's `.gpo-group` element — we only add classes,
        // leaving it exactly where Globo rendered it.
        const accordion = gpoGroup;
        accordion.classList.add('globo-v2__accordion');
        if (i > 0) accordion.classList.add('globo-v2__accordion--locked');

        // The collapsible body IS Globo's `.gpo-group__wrapper` element.
        const body = group;
        body.classList.add('globo-v2__body');

        // Toggle button is inserted as the first child of the accordion, right
        // before the content — it does not move any existing node.
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'globo-v2__toggle';
        this._setOff(btn, i);
        btn.addEventListener('click', () => {
          if (accordion.classList.contains('globo-v2__accordion--locked')) return;
          btn.getAttribute('aria-pressed') === 'true'
            ? this._close(i)
            : this._open(i);
        });
        accordion.insertBefore(btn, body);

        step.btn       = btn;
        step.body      = body;
        step.accordion = accordion;
        step.total     = total;
      });

      // Auto-open the Custom Name step
      this.steps.forEach((step, i) => {
        if (step.label.toLowerCase().includes('custom name')) {
          setTimeout(() => this._open(i), 100);
        }
      });
    }

    _labelHTML(i) {
      const { label, price } = this.steps[i];
      const priceStr = price ? ` for <strong>${price}</strong>` : '';
      return `${CHECK}<span class="globo-v2__toggle-label">Add <strong>${label}</strong>${priceStr}</span>${SWITCH}`;
    }

    _setOff(btn, i) {
      btn.setAttribute('aria-pressed', 'false');
      btn.classList.remove('is-active');
      btn.innerHTML = this._labelHTML(i);
    }

    _setOn(btn, i) {
      btn.setAttribute('aria-pressed', 'true');
      btn.classList.add('is-active');
      btn.innerHTML = this._labelHTML(i);
    }

    _open(i) {
      const step = this.steps[i];
      const { btn, body, accordion, group, total } = step;
      this._setOn(btn, i);
      accordion.classList.add('is-open');
      body.style.overflow = 'hidden';
      body.style.maxHeight = body.scrollHeight + 'px';
      body.addEventListener('transitionend', () => {
        body.style.overflow = 'visible';
        accordion.style.overflow = 'visible';
      }, { once: true });
      if (total) total.style.display = '';

      const onChange = () => {
        const done = isComplete(group);
        accordion.classList.toggle('is-done', done);
        if (done) {
          const next = this.steps[i + 1];
          if (next) next.accordion.classList.remove('globo-v2__accordion--locked');
        }
      };

      // Store so _close can remove it
      if (step._onChange) {
        group.removeEventListener('input',  step._onChange);
        group.removeEventListener('change', step._onChange);
      }
      step._onChange = onChange;

      group.addEventListener('input',  onChange);
      group.addEventListener('change', onChange);
      setTimeout(onChange, 0);
    }

    _close(i) {
      const step = this.steps[i];
      const { btn, body, accordion, group, total } = step;

      if (step._onChange) {
        group.removeEventListener('input',  step._onChange);
        group.removeEventListener('change', step._onChange);
        step._onChange = null;
      }

      this._setOff(btn, i);
      accordion.classList.remove('is-open', 'is-done');
      accordion.style.overflow = 'hidden';
      body.style.overflow = 'hidden';
      body.style.maxHeight = '0';
      if (total) total.style.display = 'none';

      // Reset values AND fire the native events Globo listens for, so Globo's
      // internal state (price, line-item properties, validation) stays in sync
      // with the visual reset. Plain `.value = ''` / `.checked = false` do not
      // dispatch events, which left Globo stale before.
      const setNativeValue = (el, value) => {
        const proto = el.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype
          : el.tagName === 'SELECT' ? HTMLSelectElement.prototype
          : HTMLInputElement.prototype;
        const setter = Object.getOwnPropertyDescriptor(proto, 'value').set;
        setter.call(el, value);
        el.dispatchEvent(new Event('input',  { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
      };

      const setNativeChecked = (el, checked) => {
        const setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'checked').set;
        setter.call(el, checked);
        el.dispatchEvent(new Event('input',  { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
      };

      group.querySelectorAll('input:not([type="hidden"]), textarea, select').forEach(el => {
        const type = (el.getAttribute('type') || '').toLowerCase();
        if (type === 'radio' || type === 'checkbox') return; // handled below
        setNativeValue(el, '');
      });
      group.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(el => {
        setNativeChecked(el, false);
      });
    }
  }

  if (!customElements.get('globo-v2')) customElements.define('globo-v2', GloboV2);
})();
